/** Clipboard helpers. Both need a tap to work on iOS. */

export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fall through to the old trick
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    ta.remove();
    return ok;
  } catch {
    return false;
  }
}

/** Reads the clipboard (iOS shows its Paste callout). Null when blocked or empty. */
export async function readText(): Promise<string | null> {
  try {
    const t = await navigator.clipboard?.readText?.();
    return t?.trim() ? t : null;
  } catch {
    return null;
  }
}
